import AdminManagementMainTable from "@/components/UserManagementComponents/Tables/adminManagementMainTable.component";
import BasePage from "@/infrastructure/BasePage/basePage.component";
import React from "react";
import { useTranslation } from "react-i18next";

type PageAdminManagementProps = {
  // TODO: add props here
};

const PageAdminManagement: React.FC<PageAdminManagementProps> = (props) => {
  const { t } = useTranslation();
  return (
    <BasePage currPage="adminManagement">
      <div className="h-full overflow-y-auto">
        <h2 className="mt-4 text-center text-2xl font-bold">
          Admin Users Management
        </h2>
        <AdminManagementMainTable />
      </div>
    </BasePage>
  );
};

export default PageAdminManagement;
